import React, { Component } from 'react';
import { Play, Shield, Eye, Clock, Users, CheckCircle, Star, ArrowRight, Phone, Mail, MapPin } from 'lucide-react';

class AI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFeature: 0,
      stats: [
    { number: '99.9%', label: 'Threat Detection Accuracy' },
    { number: '50K+', label: 'Incidents Detected' },
    { number: '1000+', label: 'Sites Protected by AI' },
    { number: '<3s', label: 'Detection Response Time' }
  ],
  features: [
    {
      icon: <Shield className="w-6 h-6" />,
      title: 'Predictive Threat Detection',
      description: 'AI models recognize risks before they escalate, enabling proactive security action.'
    },
    {
      icon: <Eye className="w-6 h-6" />,
      title: 'Behavioral Analysis',
      description: 'Track unusual human or vehicle behavior patterns in real-time.'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: 'Real-Time Alerting',
      description: 'Instant notifications sent to security personnel when AI detects anomalies.'
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Continuous Learning Systems',
      description: 'AI improves over time by learning from environments, incidents, and operator feedback.'
    }
  ],
  services: [
    {
      title: 'AI Surveillance Integration',
      description: 'Enhance your existing cameras with AI-driven detection and analytics.',
      features: ['No hardware replacement', 'Cloud-based or on-premise AI', 'HD feed compatibility']
    },
    {
      title: 'Threat Intelligence Engine',
      description: 'Continuously monitors and learns from global and local threat patterns.',
      features: ['Anomaly detection', 'Geofencing alerts', 'Facial & license recognition']
    },
    {
      title: 'Automated Incident Response',
      description: 'Trigger automated actions like lights, locks, or sirens based on AI analysis.',
      features: ['Rule-based responses', 'Live video tagging', 'Voice broadcast']
    },
    {
      title: 'Command Center Dashboard',
      description: 'A centralized hub for managing AI alerts, reports, and live footage.',
      features: ['Multi-site visibility', 'Operator actions', 'AI audit logs']
    }
  ],
  testimonials: [
    {
      name: 'Jason Patel',
      company: 'SecureTech Corp.',
      rating: 5,
      text: 'The AI system drastically reduced false alarms and helped us stop actual threats on time.'
    },
    {
      name: 'Nina Wallace',
      company: 'SmartCity Surveillance',
      rating: 5,
      text: 'It’s like having a 24/7 virtual guard that never sleeps. AI analytics are very accurate.'
    },
    {
      name: 'Tom Edwards',
      company: 'LogiPark',
      rating: 5,
      text: 'Our warehouse security is now fully automated and 10x more responsive thanks to their AI tools.'
    }
  ]
    };
  }

  componentDidMount() {
    // Auto-rotate features every 4 seconds
    this.featureInterval = setInterval(() => {
      this.setState(prevState => ({
        activeFeature: (prevState.activeFeature + 1) % prevState.features.length
      }));
    }, 4000);
  }

  componentWillUnmount() {
    if (this.featureInterval) {
      clearInterval(this.featureInterval);
    }
  }

  setActiveFeature = (index) => {
    this.setState({ activeFeature: index });
  }

  render() {
    const { activeFeature, stats, features, services, testimonials } = this.state;

    const styles = {
      root: {
        '--primary-dark': '#010A1A',
        '--secondary-dark': '#002C58',
        '--text-primary': '#ffffff',
        '--text-secondary': '#94a3b8',
        '--box-dark-bg': '#1a2332',
        '--icons-color': '#155EEF',
        '--accent-cyan': '#06b6d4',
        '--accent-blue': '#3b82f6'
      }
    };

    return (
      <div className="min-vh-100" 
           style={{
             backgroundColor: 'var(--primary-dark)',
             color: 'var(--text-primary)',
             fontFamily: 'system-ui, -apple-system, sans-serif'
           }}>
        
        {/* Banner Section */}
        <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">AI Powered Security</h1>
              <p className="hero-subtitle">Harness artificial intelligence to predict, prevent, and respond to security threats with precision and speed.</p>
            </div>
          </div>
        </section>
        {/* <section className="general-banner py-5" 
                 style={{
                   background: `linear-gradient(135deg, var(--secondary-dark) 0%, var(--primary-dark) 100%)`,
                   minHeight: '50vh',
                   display: 'flex',
                   alignItems: 'center'
                 }}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-10">
                <div className="general-content">
                  <h1 className="hero-title display-3 fw-bold mb-4" 
                      style={{
                        fontFamily: 'Orbitron, monospace',
                        color: 'var(--text-primary)',
                        textShadow: '0 0 20px rgba(21, 94, 239, 0.3)'
                      }}>
                    Live Video Monitoring & Security
                  </h1>
                  <p className="hero-subtitle " 
                     style={{ color: 'var(--text-secondary)'}}>
                    Advanced 24/7 surveillance solutions and professional monitoring services
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <button className="btn btn-lg px-4 py-2 d-flex align-items-center gap-2"
                            style={{
                              backgroundColor: 'var(--accent-blue)',
                              border: 'none',
                              borderRadius: '8px',
                              color: 'white',
                              fontWeight: '600'
                            }}>
                      Get Started <ArrowRight className="w-4 h-4" />
                    </button>
                    <button className="btn btn-outline-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                      <Play className="w-4 h-4" /> Watch Demo
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="position-relative">
                  <div className="d-inline-block p-4 rounded-circle" 
                       style={{
                         backgroundColor: 'var(--box-dark-bg)',
                         border: '2px solid var(--accent-cyan)',
                         boxShadow: '0 0 30px rgba(6, 182, 212, 0.3)'
                       }}>
                    <Shield className="w-5 h-5" style={{ width: '80px', height: '80px', color: 'var(--accent-cyan)' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Stats Section */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row g-4">
              {stats.map((stat, index) => (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className="text-center p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--primary-dark)',
                         border: '1px solid var(--secondary-dark)',
                         transition: 'transform 0.3s ease'
                       }}
                       onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
                       onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                    <h2 className="display-4 fw-bold mb-2" 
                        style={{ color: 'var(--accent-cyan)' }}>
                      {stat.number}
                    </h2>
                    <p className="mb-0" style={{ color: 'var(--text-secondary)' }}>
                      {stat.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Features Section */}
        <section className="py-5">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Advanced Security Features
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Cutting-edge technology meets professional expertise
                </p>
              </div>
            </div>
            <div className="row g-4">
              {features.map((feature, index) => (
                <div key={index} className="col-lg-6 col-md-6">
                  <div className={`p-4 h-100 rounded-3 cursor-pointer transition-all ${
                         activeFeature === index ? 'border-2' : 'border-1'
                       }`}
                       style={{
                         backgroundColor: activeFeature === index ? 'var(--secondary-dark)' : 'var(--box-dark-bg)',
                         borderColor: activeFeature === index ? 'var(--accent-blue)' : 'var(--secondary-dark)',
                         transition: 'all 0.3s ease',
                         cursor: 'pointer'
                       }}
                       onClick={() => this.setActiveFeature(index)}>
                    <div className="d-flex align-items-start gap-3">
                      <div className="p-3 rounded-2 flex-shrink-0" 
                           style={{ 
                             backgroundColor: 'var(--icons-color)', 
                             color: 'white' 
                           }}>
                        {feature.icon}
                      </div>
                      <div>
                        <h4 className="fw-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                          {feature.title}
                        </h4>
                        <p className="mb-0" style={{ color: 'var(--text-secondary)' }}>
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Our Monitoring Services
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Comprehensive security solutions tailored to your needs
                </p>
              </div>
            </div>
            <div className="row g-4">
              {services.map((service, index) => (
                <div key={index} className="col-lg-6">
                  <div className="p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--primary-dark)',
                         border: '1px solid var(--secondary-dark)'
                       }}>
                    <h4 className="fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                      {service.title}
                    </h4>
                    <p className="mb-3" style={{ color: 'var(--text-secondary)' }}>
                      {service.description}
                    </p>
                    <ul className="list-unstyled">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="d-flex align-items-center gap-2 mb-2">
                          <CheckCircle className="w-4 h-4 flex-shrink-0" 
                                      style={{ color: 'var(--accent-cyan)' }} />
                          <span style={{ color: 'var(--text-secondary)' }}>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="py-5">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Client Testimonials
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Trusted by businesses and communities worldwide
                </p>
              </div>
            </div>
            <div className="row g-4">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="col-lg-4">
                  <div className="p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--box-dark-bg)',
                         border: '1px solid var(--secondary-dark)'
                       }}>
                    <div className="d-flex gap-1 mb-3">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4" 
                              style={{ color: '#fbbf24', fill: '#fbbf24' }} />
                      ))}
                    </div>
                    <p className="mb-3" style={{ color: 'var(--text-secondary)' }}>
                      "{testimonial.text}"
                    </p>
                    <div className="border-top pt-3" 
                         style={{ borderColor: 'var(--secondary-dark) !important' }}>
                      <h6 className="fw-bold mb-1" style={{ color: 'var(--text-primary)' }}>
                        {testimonial.name}
                      </h6>
                      <small style={{ color: 'var(--text-secondary)' }}>
                        {testimonial.company}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="py-5" 
                 style={{
                   background: `linear-gradient(135deg, var(--secondary-dark) 0%, var(--accent-blue) 100%)`
                 }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Ready to Secure Your Property?
                </h2>
                <p className="lead mb-4" style={{ color: 'var(--text-primary)' }}>
                  Get started with our professional live video monitoring services today
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  <button className="btn btn-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                    <Phone className="w-4 h-4" /> Call Now: +1 (403) 992-1672
                  </button>
                  {/* <button className="btn btn-outline-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                    <Mail className="w-4 h-4" /> Get Free Quote
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Info Section */}
        {/* <section className="py-4" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Phone className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>24/7 Support: +1 (555) 123-4567</span>
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Mail className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>security@company.com</span>
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <MapPin className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>Nationwide Coverage</span>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>
    );
  }
}

export default AI;